import { render, staticRenderFns } from "./PsPatientsListTable.vue?vue&type=template&id=083c5746&scoped=true&"
import script from "./PsPatientsListTable.vue?vue&type=script&lang=js&"
export * from "./PsPatientsListTable.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsListTable.vue?vue&type=style&index=0&id=083c5746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c5746",
  null
  
)

export default component.exports